export default {
  common: {
    loading: 'Loading...',
    networkError: 'Network error, please check your network settings or contact IT5000.',
    minutes: 'min',
    hour: 'h',
    readyToStart: 'Upcoming',
    ing: 'In progres',
    finishedAuto: 'Automatically ended',
    finishedByPresenter: 'Host ends video conference',
    plsOpenInBrowser: 'Please open via browser',
    plsOpenInSafari: 'Please open via Safari',
    ok: 'ok',
    stillUse: 'Yes,continue',
    or: 'or'
  },
  meeting: {
    detail: 'Meeting info',
    chinaRecommend: 'Recommended for Midea Staff',
    outsideRecommend: 'Recommended for Partners and Guests',
    openInMission: 'Join via Midea Connect',
    openInMideaMeeting: 'Join via Midea Meeting',
    notStart: 'The meeting has not yet begun',
    hasFinished: 'The meeting  is over',
    hasCanceled: 'Meeting has been cancel',
    openMission: 'This page will open Midea Connect',
    clickDownloadMission: 'If you are not redirected or join the meeting automatically, please click Download Midea Connect',
    installedMission: 'If you have already installed Midea Connect, please',
    clickHere: 'Click here',
    openMissionTips: 'Click Open 美信 when the browser dialog box pops up',
    donwloadMissionImed: 'Download Midea Connect',
    downloadMideaMeeting: 'Download Midea Meeting',
    openMideaMeeting: 'This page will open Midea Meeting',
    clickDownload: 'If you are not redirected automatically, please click Download.',
    installedMideaMeeting: 'If you have already installed Midea Meeting please',
    browserDialogOpened: 'when the browser dialog box pops up',
    clickOpenMideaMeetingBtn: 'Click Open MideaMeeting',
    donwloadImed: 'Download now',
    dontWantToDownload: 'Not willing to download?',
    joinMeetingInBrowser: 'Join from Web Browser',
    cancelMeetingInfo: 'The meeting info below is invalid',
    otherToMeeting: 'Other joining method',
    browserMeetingTips: 'Only support Chrome/Firefox/Safari.Audio and video quality on web browsers might be unstable.',
    readingGuideline: 'View detailed operation guidance',
    openInWXMeeting: 'Join Via VooV Meeting',
    openInWXApplet: 'Join Via Mini Program',
    openTXMeeting: 'This page will open VooV Meeting',
    clickDownloadTXMeeting: 'If you are not redirected automatically, please click 【Download Now】',
    needTXMeeting: 'join the meeting via other means',
    installedTXMeeting: 'If you have already installed VooV Meeting, please ',
    openTXMeetingTips: 'When the browser dialog box pops up, click 【Open VooV Meeting】 button',
    donwloadTXMeetingImed: 'Download Now',
    downloadMX: 'Download Midea Connect',
    downloadTXMeeting: 'Download VooV Meeting',
    back: 'Back  to Meeting Details',
    isNotChinesePhone: 'If your phone number is registered in Chinese mainland, please click',
    downloadVooV: '	Download Tencent Meeting',
    scan: 'Long press to save and scan with WeChat',
    joinInMeeting: 'Join Meeting',

  }
}
